import { render, staticRenderFns } from "./ItemsListManage.vue?vue&type=template&id=2b5c7946&scoped=true"
import script from "./ItemsListManage.vue?vue&type=script&lang=js"
export * from "./ItemsListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c7946",
  null
  
)

export default component.exports